import { parseAsBoolean, useQueryState } from "nuqs";
import { useCallback } from "react";

/**
 * Hook for managing social filter state (friends attending)
 * Uses URL query parameter for state persistence
 *
 * @returns {Object} Filter state and toggle function
 * @returns {boolean} isActive - Whether the social filter is currently active
 * @returns {Function} toggle - Function to toggle the filter on/off
 *
 * @example
 * ```tsx
 * const { isActive, toggle } = useSocialFilter();
 * return <button onClick={toggle}>{isActive ? 'Hide' : 'Show'} friends</button>
 * ```
 */
export function useSocialFilter() {
	const [isActive, setIsActive] = useQueryState(
		"social",
		parseAsBoolean.withDefault(false),
	);

	const toggle = useCallback(() => {
		setIsActive((prev) => !prev);
	}, [setIsActive]);

	return { isActive, toggle };
}
